<template>
  <div class="app-main-content">
    <partner-list
      v-show="view==='list'"
      ref="partnerList"
      :service-type="serviceType"
      :is-sales-for-szfs="isSalesForSzfs"
      @rowDataChange="onRowDataChange"
      @addCompany="addHanler"
      @viewCompany="viewHandler"
      @audit="toAudit"
      @inviteB2B="inviteB2BHandler"
    />
    <partner-form v-show="view==='form'" ref="partnerForm" :service-type="serviceType" :is-sales-for-szfs="isSalesForSzfs" @rowChange="onRowChange" @audit="toAudit" @back="backToList" @refresh-data="refreshData" />
    <contact-list v-show="view==='contactList'" @back="backToList" />
    <!-- 审核弹窗 -->
    <el-dialog v-el-drag-dialog class="partner-audit-dialog" :visible.sync="auditDialog.visible" :title="$t('Partners.partnerReview')" width="420px" :close-on-click-modal="false">
      <el-form label-width="75px" label-position="right">
        <el-form-item :label="$t('Partners.RefuseRemark')+'：'">
          <el-input v-model="auditDialog.form.rejectReason" no="rejectReason" type="textarea" :rows="5" style="width: 310px" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="ok" type="primary" @click="passAudit">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="reject" type="primary" @click="notPassAudit">{{ $t('common.btn.reject') }}</el-button>
        <el-button no="cancel" @click="auditDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import partnerList from './components/partner/partnerList'
import partnerForm from './components/partner/partnerForm'
import contactList from './components/partner/contactList'
import lodash from 'lodash'
import { refreshBasicData } from '@/utils/basicDataCache'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { Company } from '@/class/model/mdm/Company'
import * as PartnerServiceItem from '@/class/cargo/model/parameters/PartnerServiceItem'
import { passAuditCompany, rejectAuditCompany } from '@/api/company'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'Partner',
  components: { partnerList, partnerForm, contactList },
  data() {
    return {
      view: 'list',
      serviceType: '',
      rowData: [],
      auditDialog: {
        visible: false,
        form: {
          uuid: '',
          rejectReason: ''
        }
      }
    }
  },
  computed: {
    // 深圳丰收销售专用
    isSalesForSzfs() {
      return String(cache.config.get('ToExoSystem')) === 'SZFS' && !this.$store.getters.isAdmin &&
        this.serviceType === PartnerServiceItem.PARTNER_CUSTOMER.code &&
        (this.$checkPermission(['role_salesOfGoods']) || this.$checkPermission(['role_RemoteBooking_queryPrivateCustom']) ||
      this.$checkPermission(['role_platform_sales']) || this.$checkPermission(['role_branchSales']) || this.$checkPermission(['role_sales']))
    }
  },
  async created() {
    /* 服务项目 */
    const index = this.$route.path.lastIndexOf('/')
    const str = this.$route.path.substr(index + 1)
    this.serviceType = str.toUpperCase() || PartnerServiceItem.PARTNER_SERVICE_ALL.code
    await cache.load(cacheName.CONFIG)
  },
  methods: {
    onRowDataChange(data) {
      this.rowData = data
    },
    onRowChange(uuid) {
      this.$refs.partnerList.addToQuery([uuid])
    },
    addHanler() {
      this.view = 'form'
      this.$refs.partnerForm.onShow('new', lodash.cloneDeep(this.rowData))
    },
    viewHandler(row) {
      this.view = 'form'
      this.$refs.partnerForm.onShow('look', lodash.cloneDeep(this.rowData), row)
    },
    toAudit(row) {
      if (row.approvedState === 1) {
        this.$message.warning(this.$t('Partners.partnerReviewed'))
        return
      }
      this.auditDialog.form = row
      this.auditDialog.form.rejectReason = ''
      this.auditDialog.visible = true
    },
    passAudit() {
      const loading = getLoading4Cxt(this)
      passAuditCompany({
        uuid: this.auditDialog.form.uuid,
        version: this.auditDialog.form.version
      }).then(res => {
        Object.assign(this.auditDialog.form, res.data)
        this.refreshData(this.auditDialog.form)
        this.auditDialog.visible = false
        this.$message.success(this.$t('Message.AuditSuccessfully'))
      }).finally(() => {
        loading.close()
      })
    },
    notPassAudit() {
      if (!this.auditDialog.form.rejectReason) {
        this.$message.warning(this.$t('Partners.fillRejectReason'))
        return
      }
      const loading = getLoading4Cxt(this)
      rejectAuditCompany({
        uuid: this.auditDialog.form.uuid,
        rejectReason: this.auditDialog.form.rejectReason,
        version: this.auditDialog.form.version
      }).then(res => {
        Object.assign(this.auditDialog.form, res.data)
        this.refreshData(this.auditDialog.form)
        this.auditDialog.visible = false
        this.$message.success(this.$t('Partners.auditRejected'))
      }).finally(() => {
        loading.close()
      })
    },
    refreshData(row) {
      refreshBasicData()
      Company.clearCache()
      this.$refs.partnerList.addToQuery([row.uuid])
      this.$refs.partnerForm.updatePartnerFormRow(row)
      if (this.view === 'form') {
        this.$refs.partnerForm.againShow('look')
      }
    },
    inviteB2BHandler() {
      this.view = 'contactList'
    },
    backToList() {
      this.view = 'list'
    }
  }
}
</script>

<style lang="scss">
#app .partner-audit-dialog {
  .el-form {
    .el-form-item {
      .el-form-item__label {
        margin-top: 35px;
      }
    }
  }
}
</style>
